import { createAddService,getAllAddService } from "../../../configs/constants";
import axios from '../../../utils/axiosInceptor';

export const createAdvertisement = async (payload,adId=null) => {
    try {
      const url = adId ?  `${createAddService}/${adId}` : `${createAddService}`;

      let response = null;
      
      if(adId){
        response = await axios.patch(url, payload);
      }else{
        response = await axios.post(url, payload);
      }
      return response;
    } catch (error) {
     console.log(error)
    }
  };


//   get all advertisement 

export const getAdvertisements = async (payload) => {
    try {
      const url = `${getAllAddService}?limit=${payload?.limit}&page=${payload?.currentPage}`;
      const response = await axios.get(url);
      return response;
    } catch (error) {
     console.log(error)
    }
  };